module.exports = __webpack_public_path__ + "img/unlink.633e481e.gif";